/* unplugin-vue-components disabled */import { render } from "./templateDemeRadioEdit.vue?vue&type=template&id=32be84d8&scoped=true"
import script from "./templateDemeRadioEdit.vue?vue&type=script&lang=js"
export * from "./templateDemeRadioEdit.vue?vue&type=script&lang=js"

import "./templateDemeRadioEdit.vue?vue&type=style&index=0&id=32be84d8&scoped=true&lang=css"

import exportComponent from "/home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32be84d8"]])

export default __exports__